import { fb, validators } from '../../../lib/form';
export function GetProfileModel(data){
  const model = fb.group({
    firstName: [data.firstName || '', [validators.Required()], { label: 'First Name', type: 'text' }],
    lastName: [data.lastName || '', [], { label: 'Last Name', type: 'text' }],
    nickName: [data.nickName || '', [validators.Required()], { label: 'Nick Name', type: 'text' }],
    phone: [data.phone || '', [], { label: 'Phone', type: 'text' }]
  }); 
  return model;
}